import { NONE } from '../../constants/constants';

const INITIAL_STATE = {
  playerDocument: '',
  disableSkipAheadButton: false,
  disableSkipBackButton: false,
  showSkipButton: false,
  forward: false,
  backward: false,
  resource: '',
  flagAdded: false,
  isPaused: false,
  resetProgress: false,
  allDocuments: [],
  fullDocuments: [],
  allSeasons: [],
  fromPlaylistTab: false,
  storeProgress: false,
  feedUrl: '',
  newDocumentInLast5: false,
  season: NONE,
  fromSkip: false,
  podcastSeasons: [],
  onPlaylist: false,
  sameProgress: false,
  playerFlag: '',
  isSelectedFlags: false,
  timeProgress: 0,
  showPollyPlayerSkipButton: false
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'UPDATE_POLLY_PLAYER_SKIP_BUTTON': {
      return { ...state, showPollyPlayerSkipButton: action.showPollyPlayerSkipButton };
    }
    case 'UPDATE_DOCUMENT_BEFORE_FILTER_CHANGE_UUID': {
      return { ...state, documentBeforeFilterChangeUuid: action.payload };
    }
    case 'SET_PLAY_RESOURCE': {
      return { ...state, resource: action.payload };
    }
    case 'SET_PLAYER_DOCUMENT': {
      return { ...state, playerDocument: action.payload };
    }
    case 'SET_DISABLE_SKIP_AHEAD_BUTTON': {
      return { ...state, disableSkipAheadButton: action.payload };
    }
    case 'SET_DISABLE_SKIP_BACK_BUTTON': {
      return { ...state, disableSkipBackButton: action.payload };
    }
    case 'SET_SHOW_SKIP_BUTTON': {
      return { ...state, showSkipButton: action.payload };
    }
    case 'SET_PRESS_FORWARD_BUTTON': {
      return { ...state, forward: action.payload };
    }
    case 'SET_PRESS_BACKWARD_BUTTON': {
      return { ...state, backward: action.payload };
    }
    case 'SET_FLAG_ADDED': {
      return { ...state, flagAdded: action.payload };
    }
    case 'SET_IS_PAUSED': {
      return { ...state, isPaused: action.payload };
    }
    case 'RESET_PROGRESS': {
      return { ...state, resetProgress: action.payload };
    }
    case 'SET_ALL_DOCUMENTS': {
      return { ...state, allDocuments: action.payload };
    }
    case 'SET_FULL_SERIAL_DOCUMENTS': {
      return { ...state, fullDocuments: action.payload };
    }
    case 'SET_ALL_SEASONS': {
      return { ...state, allSeasons: action.payload };
    }
    case 'SET_FROM_PLAYLIST_TAB': {
      return { ...state, fromPlaylistTab: action.payload };
    }
    case 'SET_STORE_PROGRESS': {
      return { ...state, storeProgress: action.payload };
    }
    case 'SET_FEED_URL': {
      return { ...state, feedUrl: action.payload };
    }
    case 'SET_NEW_DOCUMENT_IN_LAST_5': {
      return { ...state, newDocumentInLast5: action.payload };
    }
    case 'SET_SEASON': {
      return { ...state, season: action.payload };
    }
    case 'SET_FROM_SKIP': {
      return { ...state, fromSkip: action.payload };
    }
    case 'RESET_PLAYER': {
      return INITIAL_STATE;
    }
    case 'SET_PODCAST_SEASONS': {
      return { ...state, podcastSeasons: action.payload };
    }
    case 'SET_ON_PLAYLIST': {
      return { ...state, onPlaylist: action.payload };
    }
    case 'SAME_PROGRESS': {
      return { ...state, sameProgress: action.payload };
    }
    case 'SET_PLAYER_FLAG': {
      return { ...state, playerFlag: action.payload };
    }
    case 'SET_IS_SELECTED_FLAGS': {
      return { ...state, isSelectedFlags: action.payload };
    }
    case 'SET_TIME_PROGRESS': {
      return { ...state, timeProgress: action.payload };
    }
    default:
      return state;
  }
}
